import { FC } from 'react';

import { PlusIcon } from '../../assets/icons/index';
import img from '../../assets/images/clipboard-v2.png';
import { AppFormattedMessage } from '../../components/app-formatted-message/index';
import Button from '../../components/button/index';
import { useLocale } from '../../hooks/index';
import { PoolPlansTab } from '../../types/pool-plans.types';

export type EmptyPoolsProps = {
  isMobile?: boolean;
  onAddPlanClick?: () => void;
  onAddPoolClick?: () => void;
  selectedTab: PoolPlansTab;
};

export const EmptyPools: FC<EmptyPoolsProps> = ({
  selectedTab,
  onAddPlanClick,
  onAddPoolClick,
  isMobile,
}) => {
  const { messagesLocale } = useLocale();
  return (
    <div className="radial-gradient-border-yellow centered relative m-auto my-20 flex h-fit flex-col gap-6 rounded-2xl px-6 py-8 lg:max-w-[393px]">
      <div
        className="rounded-full bg-white p-3"
        style={{
          boxShadow: '0px 0px 8px 0px #0985F721 inset',
        }}
      >
        <div
          className="centered flex size-28 items-center gap-3 rounded-full"
          style={{
            background:
              ' linear-gradient(180deg, rgba(253, 113, 34, 0.13) 0%, rgba(220, 55, 3, 0.13) 100%)',
          }}
        >
          <div className="size-[56px] object-cover">
            <img alt="" src={img} />
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center gap-2">
        <span
          className="!bg-clip-text text-xl font-semibold text-transparent"
          style={{
            background: 'linear-gradient(132.59deg, #475467 29.58%, #101828 84.27%)',
          }}
        >
          {selectedTab === PoolPlansTab.TERMINATED
            ? messagesLocale['NO_TERMINATED_POOLS_OR_PLANS']
            : messagesLocale['NO_POOLS_OR_PLANS']}
        </span>
        <span className="max-w-[323px] text-center text-xs font-[450] text-gray-500">
          {selectedTab === PoolPlansTab.TERMINATED
            ? messagesLocale['TERMINATED_POOLS_AND_PLANS_WILL_HERE']
            : messagesLocale['POOLS_AND_PLANS_WILL_HERE']}
        </span>
      </div>

      {selectedTab === PoolPlansTab.ACTIVE && !isMobile && (
        <div className="flex gap-6" data-permission-required>
          <Button className="gap-1 px-4 py-2" onClick={onAddPoolClick}>
            <PlusIcon />
            <span className="text-nowrap text-sm font-[450] text-white">
              <AppFormattedMessage id="ADD_POOL" />
            </span>
          </Button>
          <Button className="gap-1 px-4 py-2" onClick={onAddPlanClick}>
            <PlusIcon />
            <span className="text-nowrap text-sm font-[450] text-white">
              <AppFormattedMessage id="ADD_PLAN" />
            </span>
          </Button>
        </div>
      )}
    </div>
  );
};
